export enum MessageStatusEnum {
  IS_SENT = 'IS_SENT',
  IS_RECEIVED = 'IS_RECEIVED',
  IS_READ = 'IS_READ',
  IS_SYS = 'IS_SYS'
}
